import { render } from "./AddInvoice.vue?vue&type=template&id=5633cfce"
import script from "./AddInvoice.vue?vue&type=script&lang=js"
export * from "./AddInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__